import { TranslateService } from "@ngx-translate/core";
import _ from "lodash";
import { ValidationContext } from "~app/common/validation/validationContext";
import { ValidationErrorLevels } from "~app/common/validation/ValidationErrorLevels";
import { ValidationScopes } from "~app/common/validation/ValidationScopes";
import { ILeverantorsorderDetailRad } from "../models/leverantorsorder-detail-model";

export class LeverantorsorderradValidation {
    static init(
        translateService: TranslateService,
        levorderrad: ILeverantorsorderDetailRad): ValidationContext {
        const context = new ValidationContext();
        context.errorLevel = ValidationErrorLevels.error;
        context.create(ValidationScopes.skapa).withRules([
            {
                errorLevel: ValidationErrorLevels.error,
                id: 1,
                message: { text: translateService.instant("LEVERANTORSORDER_DETAIL_ROW_HANDELSSORTIMENTSGRUPP_VALIDATION") },
                model: () => levorderrad.handelssortimentsgrupp,
                name: "handelssortimentgrupp",
                required: true
            },
            {
                errorLevel: ValidationErrorLevels.error,
                id: 2,
                message: { text: translateService.instant("LEVERANTORSORDER_DETAIL_ROW_MATTSLAG_VALIDATION") },
                model: () => levorderrad.mattslag,
                required: true,
                name: "mattslag"
            },
            {
                errorLevel: ValidationErrorLevels.error,
                id: 3,
                message: { text: translateService.instant("LEVERANTORSORDER_DETAIL_ROW_KVANTITET_VALIDATION") },
                model: () => levorderrad.kvantitet,
                name: "kvantitet",
                expression: (value, oldVal) => !_.isNil(value) && value >= 0
            },
            {
                errorLevel: ValidationErrorLevels.error,
                id: 4,
                message: { text: translateService.instant("LEVERANTORSORDER_DETAIL_ROW_AVTALSPERIODFRAN_VALIDATION") },
                model: () => levorderrad.periodFrom,
                name: "periodFrom",
                required: true
            },
            {
                errorLevel: ValidationErrorLevels.error,
                expression: (periodTom) => !!periodTom && levorderrad.periodFrom <= periodTom,
                id: 5,
                message: { text: translateService.instant("LEVERANTORSORDER_DETAIL_ROW_AVTALSPERIODTOM_VALIDATION") },
                model: () => levorderrad.periodTom,
                name: "periodTom",
                required: true
            }
        ]);
        return context;
    }
}
